import { render, staticRenderFns } from "./model-list.vue?vue&type=template&id=161c6552&scoped=true"
import script from "./model-list.vue?vue&type=script&lang=js"
export * from "./model-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161c6552",
  null
  
)

export default component.exports